import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Switch, Tab, Tabs } from "@material-ui/core";
import AllCalibrationPage from "./calibrations-all/calibrations-all-page";
import AveragedCalibrationsPage from "./averaged-calibrations/averaged-calibrations-page";
import BluetoothSpeakerCalibrationsPage from "./bluetooth-speaker-calibrations/bluetooth-speaker-calibrations-page";
import CalibrationStatisticsPage from "./statistics/calibration-statistics-page";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TabPanel from "./utils/TabPanel";
import { prefetchCalibrationStatistics } from "./utils/NetworkHandler";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CalibrationsPage() {
  const [value, setValue] = useState(0);
  const [isDetailedData, setIsDetailedData] = useState(false);
  const [statisticsPrefetching, setStatisticsPrefetching] = useState(true);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    let active = true;
    prefetchCalibrationStatistics()
      .catch(() => undefined)
      .finally(() => {
        if (active) setStatisticsPrefetching(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Box>
          {value !== 0 && (
            <FormControlLabel
              label="Zaawansowane dane"
              control={
                <Switch
                  checked={isDetailedData}
                  onChange={() => setIsDetailedData((prevState) => !prevState)}
                  name="details"
                  color="primary"
                />
              }
            />
          )}
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="zakładki kalibracji"
          >
            <Tab
              label={
                <Box display="flex" alignItems="center" gridGap={8}>
                  Statystyki
                  {statisticsPrefetching && (
                    <CircularProgress
                      size={14}
                      aria-label="Pobieranie statystyk w tle"
                    />
                  )}
                </Box>
              }
              {...a11yProps(0)}
            />
            <Tab label="Wszystkie Kalibracje" {...a11yProps(1)} />
            <Tab label="Uśrednione Kalibracje" {...a11yProps(2)} />
            <Tab label="Kalibracje głośnika BT" {...a11yProps(3)} />
          </Tabs>
        </Box>
      </Box>
      <TabPanel value={value} index={0}>
        <CalibrationStatisticsPage />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AllCalibrationPage isDetailedData={isDetailedData} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <AveragedCalibrationsPage isDetailedData={isDetailedData} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <BluetoothSpeakerCalibrationsPage isDetailedData={isDetailedData} />
      </TabPanel>
    </Box>
  );
}
